import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import aboutImage from '../images/about.jpg';

import '../css/section.css';
import Footer from '../components/Footer';

const About = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const fadeInUp = {
        hidden: { opacity: 0, y: -40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
    };

    const slideInLeft = {
        hidden: { opacity: 0, x: -50 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
    };

    const slideInRight = {
        hidden: { opacity: 0, x: 50 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
    };

    return (


        <>

            <div className='headings'>
                <h3>About Us</h3>
            </div>

            <section className="py-5 aboutsection white-text-section" id="about" aria-labelledby="about-heading">
                <div className="container">
                    {/* Section Header */}
                    <motion.div
                        className="text-center mb-5"
                        initial="hidden"
                        whileInView="visible"
                        variants={fadeInUp}
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <h2 id="about-heading" className="display-7 fw-bold mb-3">
                            A S Traders - Transforming Spaces in Lucknow
                        </h2>
                        <p className="lead text-center">
                            A S Traders - PVC Panel Wholesaler in Lucknow || Wallpaper Dealer in Lucknow || Interior Designer in Lucknow ||
                        </p>
                    </motion.div>

                    {/* Content Row */}
                    <div className="row g-4 align-items-center">
                        {/* Image */}
                        <motion.div
                            className="col-md-6"
                            initial="hidden"
                            whileInView="visible"
                            variants={slideInLeft}
                            viewport={{ once: true, amount: 0.2 }}
                        >
                            <img
                                src={aboutImage}
                                alt="Interior design showcase"
                                className="img-fluid rounded shadow"
                            />
                        </motion.div>

                        {/* Text Content */}
                        <motion.div
                            className="col-md-6"
                            initial="hidden"
                            whileInView="visible"
                            variants={slideInRight}
                            viewport={{ once: true, amount: 0.2 }}
                        >
                            <h3 className="h4 fw-semibold mb-3">About A S Traders</h3>
                            <p className="mb-4">
                                Founded with  a passion for elevating interiors, A S Traders is a leading name in Lucknow, Uttar Pradesh, renowned as a premier PVC Panel Wholesaler, Wallpaper Dealer, and Interior Designer. Since our inception, we have been committed to delivering high-quality, affordable, and trending interior solutions that cater to a diverse clientele, including homes, offices, hotels, malls, and commercial establishments. Our extensive product range and bespoke interior design services make us a one-stop destination for all your interior needs.
                            </p>

                            <h3 className="h4 fw-semibold mb-3">Our Offerings</h3>
                            <p className="mb-4">
                                At A S Traders, we pride ourselves on offering a wide variety of innovative and stylish interior products, sourced from top manufacturers to ensure quality and durability. Our product portfolio includes:
                            </p>


                        </motion.div>
                    </div>
                </div>
            </section>

            <Footer />

        </>
    );
};

export default About;